/* eslint-disable no-console */
import { setDealerAvailabilityStatus } from './dealer-availability-status';
import { initEmailSignupForm } from './email-signup-form';
import { clearInputValues, removeAllErrors, validate } from '../../utils/form-validation-utils';

const clearDealerLoookupFormData = () => {
  const form = document.querySelector('.dealer-lookup-form');
  removeAllErrors(form);
  clearInputValues(form);
};

const checkAvailability = (options) => {
  const {
    address,
    radius,
    onDealerAvailable,
    onDealerNotAvailable,
    onError,
    submitLocalTest,
  } = options;
  const requestUrl = window.getLocationsPath;
  const postData = `brandcode=${window.brandCode}&countrycode=US&latitude=0&longitude=0&address=${address}&radius=${radius}&results=10&netsales=0`;
  const request = new XMLHttpRequest();
  request.open('POST', requestUrl, true);
  request.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
  request.onload = () => {
    if (request.status >= 200 && request.status < 400) {
      const data = JSON.parse(request.responseText);
      const locationsWrapper = data['get-locations-response'];
      if (!locationsWrapper) {
        onError();
      }
      const results = locationsWrapper.locations;
      if (results.length > 0 && onDealerAvailable) {
        onDealerAvailable();
      }
      if (results.length === 0 && onDealerNotAvailable) {
        onDealerNotAvailable();
      }
    }
  };
  request.onerror = () => {
    if (onError) {
      onError();
    }
  };
  // LOCAL TESTING
  if (window.localTesting && submitLocalTest) {
    submitLocalTest();
    return;
  }
  request.send(postData);
};

const updateModalHeight = () => {
  const modalDiv = document.querySelector('.dealer-availability-modal');
  const contentHeight = modalDiv.querySelector('.modal-content').offsetHeight;
  modalDiv.querySelector('.modal-panel').style.height = `${contentHeight + 30}px`;
};

const showDefaultState = () => {
  const modalDiv = document.querySelector('.dealer-availability-modal');
  modalDiv.querySelector('.default-state').classList.remove('hidden');
  modalDiv.querySelector('.dealer-lookup-form').classList.remove('hidden');
  modalDiv.querySelector('.default-state h2').focus();
  modalDiv.querySelector('.no-dealer-state').classList.add('hidden');
  modalDiv.querySelector('.email-signup-form').classList.add('hidden');
  modalDiv.querySelector('.dealer-available-state').classList.add('hidden');
  modalDiv.querySelector('.thank-you-state').classList.add('hidden');
};

const showConfirmationState = (options) => {
  const {
    address,
    radius,
  } = options;
  const modalDiv = document.querySelector('.dealer-availability-modal');
  const contactDealerBtn = modalDiv.querySelector('.contact-a-dealer-btn');
  const contactDealerBtnHref = contactDealerBtn.getAttribute('href');
  modalDiv.querySelector('.default-state').classList.add('hidden');
  modalDiv.querySelector('.dealer-lookup-form').classList.add('hidden');
  modalDiv.querySelector('.dealer-available-state').classList.remove('hidden');
  modalDiv.querySelector('.dealer-available-state h2').focus();
  // Update url on .contact-a-dealer-btn
  if (contactDealerBtn) {
    const url = `${contactDealerBtnHref}?zipcode=${address}&radius=${radius}`;
    contactDealerBtn.setAttribute('href', url);
  }
  updateModalHeight();
};

const showNoDealersState = () => {
  const modalDiv = document.querySelector('.dealer-availability-modal');
  modalDiv.querySelector('.default-state').classList.add('hidden');
  modalDiv.querySelector('.dealer-lookup-form').classList.add('hidden');
  modalDiv.querySelector('.no-dealer-state').classList.remove('hidden');
  modalDiv.querySelector('.no-dealer-state h2').focus();
  modalDiv.querySelector('.email-signup-form').classList.remove('hidden');
  modalDiv.querySelector('.thank-you-state').classList.add('hidden');
  initEmailSignupForm();
  updateModalHeight();
};

const initDealerLoookupForm = () => {
  const modalDiv = document.querySelector('.dealer-availability-modal');
  const form = modalDiv.querySelector('.dealer-lookup-form');
  const formError = form.querySelector('.form-error-message');
  const submitBtn = form.querySelector('.submit-btn');
  const zipIpt = form.querySelector('#availabilityZipCode');
  const radiusIpt = window.dealerAvailabilityCheckRadius;

  const disableSubmitBtn = () => {
    submitBtn.setAttribute('disabled', 'disabled');
    submitBtn.value = 'Searching...';
  };

  const enableSubmitBtn = () => {
    submitBtn.removeAttribute('disabled');
    submitBtn.value = 'Submit';
  };

  const showFormError = () => {
    formError.classList.remove('hidden');
    updateModalHeight();
    formError.focus();
  };

  const hideFormError = () => {
    formError.classList.add('hidden');
    updateModalHeight();
  };

  const submitForm = () => {
    removeAllErrors(form);
    hideFormError();
    if (validate(form)) {
      disableSubmitBtn();
      checkAvailability({
        address: zipIpt.value,
        radius: radiusIpt,
        onDealerAvailable: () => {
          setDealerAvailabilityStatus('yes');
          showConfirmationState({
            address: zipIpt.value,
            radius: radiusIpt,
          });
          enableSubmitBtn();
        },
        onDealerNotAvailable: () => {
          setDealerAvailabilityStatus('no');
          showNoDealersState();
          enableSubmitBtn();
        },
        onError: () => {
          enableSubmitBtn();
          showFormError();
        },
      });
    } else {
      updateModalHeight();
    }
  };

  submitBtn.addEventListener('click', (event) => {
    event.preventDefault();
    submitForm();
  });
};

export {
  checkAvailability,
  clearDealerLoookupFormData,
  initDealerLoookupForm,
  showConfirmationState,
  showDefaultState,
  showNoDealersState,
};
/* eslint-enable no-console */
